export default "__VITE_ASSET__Dhatdg8G__"